import { jsx as _jsx } from "react/jsx-runtime";
import { AccordionDetails } from "@mui/material";
import { forwardRef } from "react";
export const UiAccordionDetails = forwardRef((props, ref) => _jsx(AccordionDetails, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_accordion_details.js.map